import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpRepositoryService } from '../../../core/http-repository.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../nav-menu/user-company.service';


declare var $: any;
declare var Toast: any;

@Component({
  selector: 'validate-token',
  templateUrl: './validate-token.component.html',
  styleUrls: ['./validate-token.component.css']
})

export class ValidateTokenComponent implements OnInit, OnDestroy {

  private contactListTokens: ContactListTokens[] = [];
  private contactListTokenError: ContactListTokens[] = [];
  public isValdate: boolean = false;
  private tokensFromCampaign: string[];
  private selectedContactListId: number[];
  private selectedCompany: number;
  private validateTokenBtn: any;
  private spinnerBtn: any;
  private successIcon: any;
  private errorIcon: any;
  public isClicked: boolean = false;
  public dispErrMsg: boolean = false;
  private subs = new SubSink();

  constructor(private repository: HttpRepositoryService, private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;
    });
  }

  public setTokensFromCampaign(tokens: string[]) {
    this.tokensFromCampaign = tokens ? tokens : [];
  }

  public setSelectedContactList(selected: number[]) {
    this.selectedContactListId = selected ? selected : [];
  }

  private loadData() {
    this.subs.sink = this.repository.get<ContactListTokens[]>('api/Campaign/Tokens?' + this.selectedContactListId.map(x => 'ids=' + x + '&').join("") + 'companyId=' + this.selectedCompany).subscribe(resp => {
      if (resp.statusCode == 200) {
        this.contactListTokens = resp.data;
        this.validateTokens();
      } else {
        Toast.Show(resp.error, 'Campaign tokens', 'error');
      }
    });

    this.isClicked = true;
  }

  private validateTokens() {
    let that = this;
    this.validateTokenBtn = $('#validateTokenBtn');
    this.spinnerBtn = $('#validateTokenSpinner');
    this.successIcon = $('#validateTokenSuccess');
    this.errorIcon = $('#validateTokenError');

    if (this.tokensFromCampaign.length > 0) {
      this.tokensFromCampaign.forEach(token => {

        if (that.contactListTokens.length > 0) {
          that.contactListTokens.forEach(clt => {
            that.spinnerBtn.fadeIn('fast');

            if (clt.tokens.indexOf(token) === -1) {
              let existingContactListInTokennErr = this.contactListTokenError.find(x => x.contactListName == clt.contactListName);

              if (existingContactListInTokennErr) {
                existingContactListInTokennErr.tokens.push(token);
              } else {
                let tokenError = new ContactListTokens();
                tokenError.contactListName = clt.contactListName;
                tokenError.tokens.push(token);

                that.contactListTokenError.push(tokenError);
              }

            }
          });
        }
      });
    }

    if (this.contactListTokenError.length > 0) {
      this.spinnerBtn.fadeOut('fast', function () {
        that.validateTokenBtn.removeClass('btn-primary');
        that.errorIcon.fadeIn('fast');
        that.validateTokenBtn.addClass('btn-danger');
      });
      this.isValdate = false;
    } else {
      this.spinnerBtn.fadeOut('fast', function () {
        that.validateTokenBtn.removeClass('btn-primary');
        that.successIcon.fadeIn('fast');
        that.validateTokenBtn.addClass('btn-success');
      });

      this.isValdate = true;
    }

    that.validateTokenBtn.prop('disabled', true);
    this.dispErrMsg = false;
  }

  public resetContactListTokenError() {
    this.contactListTokenError = [];
    this.isValdate = false;
    this.resetValidateBtn();
  }

  public resetValidateBtn() {
    if (this.successIcon) {
      if (this.successIcon.is(':visible'))
        this.successIcon.hide();
    }

    if (this.errorIcon) {
      if (this.errorIcon.is(':visible'))
        this.errorIcon.hide();
    }

    if (this.validateTokenBtn) {
      if (this.validateTokenBtn.hasClass('btn-danger')) {
        this.validateTokenBtn.removeClass('btn-danger');
        this.validateTokenBtn.addClass('btn-primary')
      }

      if (this.validateTokenBtn.hasClass('btn-success')) {
        this.validateTokenBtn.removeClass('btn-success');
        this.validateTokenBtn.addClass('btn-primary')
      }

      this.validateTokenBtn.prop('disabled', false);
      this.isClicked = false;
      this.dispErrMsg = false;
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}


export class ContactListTokens {
  contactListName: string;
  tokens: string[];

  constructor(name?: string, tokens?: string[]) {
    this.contactListName = name;
    this.tokens = tokens ? tokens : [];
  }
}
